import { useCallback, useEffect } from 'react';
import { useCoreClient } from '@hooks';
import { loadingState, notificationErrorState } from '@states';
import { useRecoilState } from 'recoil';
import { shopifyPrePurchaseWidgetState } from 'src/states/widget';
import { useCoreClientSafe } from '@utils/core-client';

export const useFetchShopifyPrePurchaseWidget = () => {
  const [, setLoading] = useRecoilState(loadingState);
  const [shopifyPrePurchaseWidget, setShopifyPrePurchaseWidget] =
    useRecoilState(shopifyPrePurchaseWidgetState);
  const [, setNotificationError] = useRecoilState(notificationErrorState);
  const coreClient = useCoreClient();
  const coreClientSafe = useCoreClientSafe();

  const fetchPrePurchaseWidget = useCallback(async () => {
    const { data, errors } = await coreClientSafe({
      args: {},
      fn: coreClient().Widget.getShopifyPrePurchase,
    });

    if (errors) {
      setNotificationError(errors);
    } else {
      setShopifyPrePurchaseWidget(data);
    }

    setLoading(false);
  }, [
    coreClient,
    coreClientSafe,
    setLoading,
    setNotificationError,
    setShopifyPrePurchaseWidget,
  ]);

  useEffect(() => {
    fetchPrePurchaseWidget();
  }, [fetchPrePurchaseWidget]);

  return {
    fetchPrePurchaseWidget,
    setShopifyPrePurchaseWidget,
    shopifyPrePurchaseWidget,
  };
};
